export default function formatTaskTitle(title, description) {
  const trimmedTitle = typeof title === 'string' ? title.trim() : '';
  if (trimmedTitle) return trimmedTitle;

  const trimmedDescription = typeof description === 'string' ? description.trim() : '';
  return trimmedDescription || '--';
}
